import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { empty, isUndefined, prepareResponseData } from "../../Utilities/utils";

// image
import appLogo from "../../assets/logo/white-logo.png";

// component
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import InputField from "../../components/form/InputField";
import { ProgressSpinner } from "primereact/progressspinner";

// css
import "./Signin.css";

// apis
import authenticationApi from "../../api/Authentication";
import { useRef } from "react";
import { Toast } from "primereact/toast";

const initialValues = {
  access_code: "",
};

const validationSchema = Yup.object().shape({
  access_code: Yup.string().min(6).max(6).required("Access Code is required."),
});

// start
function TwoFactorAuthentication() {
  const toastTR = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState();

  //alert functions
  const responseDailog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    setEmail(location?.state?.email || "");
  }, [location]);

  const handleSubmit = async (values) => {
    try {
      if (!isLoading) setIsLoading(true);
      const access_code =
        !isUndefined(values) && !isUndefined(values.access_code)
          ? values.access_code
          : "";
      const response = await authenticationApi.twoFactorAuthentication(
        email,
        access_code,
      );
      setIsLoading(false);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || empty(response_data.success)) {
        return responseDailog(
          "error",
          "Something went wrong",
          response_data?.response || "Please refresh or try again later!",
        );
      }
      navigate("/dashboard");
    } catch (error) {
      responseDailog("error", "Internal Server Error", "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signInBox">
      <aside className="leftSide">
        <div className="formBox">
          <div className="welcome">
            <p className="sectionTitle">
              <strong>TWO FACTOR AUTHENTICATION</strong>
            </p>
            <span>Enter the six(6) digit access code sent to your email</span>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form style={{ width: "100%" }}>
              <InputField
                placeholder="Access Code"
                name="access_code"
                type="text"
                icon="key"
                height={50}
                fontSize={16}
              />

              <ButtonIcon
                height={45}
                marginTop={5}
                color="#ffffff"
                backgroundColor="#633ccd"
                width="100%"
                borderColor="#633ccd"
                buttonText={
                  isLoading ? (
                    <ProgressSpinner
                      style={{ width: 25, height: 25 }}
                      strokeWidth={7}
                      animationDuration={0.5}
                    />
                  ) : (
                    "Submit"
                  )
                }
                type="submit"
              />
              <div style={{ marginTop: 15, fontSize: 14 }}>
                <NavLink to="/" style={{ textDecoration: "none" }}>
                  Back to home page
                </NavLink>
              </div>
            </Form>
          </Formik>
        </div>
      </aside>
      <aside className="rightSide">
        <img
          style={{ width: "10rem", height: "auto" }}
          src={appLogo}
          alt="School logo"
        />
        <span style={{ fontSize: "1.8rem", fontWeight: "bold" }}>
          Anciemdemia
        </span>
        <span>School Management System</span>
      </aside>
      <Toast ref={toastTR} position="bottom-left" />
    </div>
  );
}

export default TwoFactorAuthentication;
